import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { OrdersRouteNames, OrdersRoutePathNames } from '../../../../enums';

const Component = () => import('./OrderRefund.vue');

export default {
  path: buildChildURL(OrdersRoutePathNames.REFUND),
  name: OrdersRouteNames.ORDER_DETAILS_REFUND,
  component: Component,
} as RouteRecordRaw;
